"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailPayloadTemplate = void 0;
var EmailPayloadTemplate;
(function (EmailPayloadTemplate) {
    EmailPayloadTemplate["CLIENT_INQUIRY"] = "client-inquiry";
})(EmailPayloadTemplate || (exports.EmailPayloadTemplate = EmailPayloadTemplate = {}));
